import { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import closeCircle from '../assets/images/icons/close-circle.svg'

const useConfirm = () => {
    const [promise, setPromise] = useState(null);

    const confirm = () => new Promise((resolve) => {
        setPromise({ resolve });
    });

    const handleClose = () => {
        setPromise(null);
    };

    const handleConfirm = () => {
        promise?.resolve(true);
        handleClose();
    };

    const handleCancel = () => {
        promise?.resolve(false);
        handleClose();
    };

    const ConfirmationDialog = () => (
        <Modal isOpen={promise !== null} toggle={handleCancel} centered>
            <div className="modal-header">
                <h1 className="modal-title fs-5">Are you sure?</h1>
                <button type="button" className="btn-close" onClick={handleCancel} aria-label="Close">
                    <img src={closeCircle} alt="close-circle" />
                </button>
            </div>
            <ModalBody>
                <p>This action cannot be undone. Do you really want to delete this Sub Admin? </p>
                <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-dark" onClick={handleCancel}>Cancel</button>
                    <button type="button" className="btn btn-primary mx-2" onClick={handleConfirm}>Confirm</button>
                </div>
            </ModalBody>
        </Modal>
    );
    return [ConfirmationDialog, confirm];
};

export default useConfirm;